import { blobToBase64, useDevice } from "./utils";

export const messageTexts = {
  RFA1: "Starta BankID-appen.",
  RFA1B: "Starta BankID-appen och läs av QR koden.",
  RFA3: "Åtgärden avbruten. Försök igen.",
  RFA4: "En identifiering eller underskrift för det här personnumret är redan påbörjad. Försök igen.",
  RFA5: "Internt tekniskt fel. Försök igen.",
  RFA6: "Åtgärden avbruten.",
  RFA8: "BankID-appen svarar inte. Kontrollera att den är startad och att du har internetanslutning. Om du inte har något giltigt BankID kan du hämta ett hos din Bank. Försök sedan igen.",
  RFA9: "Skriv in din säkerhetskod i BankID-appen och välj Legitimera eller Skriv under.",
  RFA15B:
    "Söker efter BankID, det kan ta en liten stund... Om det har gått några sekunder och inget BankID har hittats har du sannolikt inget BankID som går att använda för den aktuella identifieringen/underskriften i den här enheten. Om du inte har något BankID kan du hämta ett hos din internetbank.",
  RFA16:
    "Det BankID du försöker använda är för gammalt eller spärrat. Använd ett annat BankID eller hämta ett nytt hos din internetbank.",
  RFA17:
    "BankID-appen verkar inte finnas i din dator eller telefon. Installera den och hämta ett BankID hos din internetbank. Installera appen från din appbutik eller https://install.bankid.com.",
  RFA17B:
    "Misslyckades att läsa av QR koden. Starta BankID-appen och läs av QR koden. Kontrollera att BankID-appen är uppdaterad. Om du inte har BankID-appen måste du installera den och hämta ett BankID hos din internetbank. Installera appen från din appbutik eller https://install.bankid.com.",
  RFA22: "Okänt fel. Försök igen.",
};

export function getBankidLink(autoStartToken) {
  return `bankid:///?autostarttoken=${autoStartToken}&redirect=null`;
}

export function getAppBankidLink(autoStartToken) {
  return `https://app.bankid.com/?autostarttoken=${autoStartToken}&redirect=null`;
}

export function getIOSBankidLink(autoStartToken) {
  const returnUrl = getIOSReturnUrl();
  return `https://app.bankid.com/?autostarttoken=${autoStartToken}&redirect=${returnUrl}`;
}

function getIOSReturnUrl() {
  const device = useDevice();
  if (device.isChromeOnAppleDevice) {
    return encodeURIComponent("googlechrome://");
  }
  if (device.isFirefoxOnAppleDevice) {
    return encodeURIComponent("firefox://");
  }
  if (device.isOperaTouchOnAppleDevice) {
    return encodeURIComponent(
      `${window.location.href.replace("http", "touch-http")}#initiated=true`
    );
  }
  return encodeURIComponent(`${window.location.href}#initiated=true`);
}

export async function setBankIdQrImage(data) {
  await blobToBase64(data).then((res) => {
    $("#bank-id-qr-image img").attr("src", `${res}`);
  });
}

export function handleDonePollStatusResponse(res, isQr, isSameDevice) {
  var shouldRequestNewQrCode = true;
  if (messageTexts.hasOwnProperty(res.messageCode)) {
    var messageCode = res.messageCode;
    if ((messageCode === "RFA1" || messageCode === "RFA17") && isQr) {
      messageCode = messageCode + "B";
    }
    if (messageCode === "RFA9" && isQr) {
      shouldRequestNewQrCode = false;
      $("#bank-id-qr-image").hide();
      $("#spinner").removeClass("hidden");
    }
    isSameDevice
      ? $("#bank-id-same-device-status p").text(messageTexts[messageCode])
      : $("#bank-id-qr-status p").text(messageTexts[messageCode]);
  }
  return shouldRequestNewQrCode;
}
